import "../scss/page.scss";

import "../scss/ecommerce.scss";

import "jquery-match-height";

import "./scripts/ecommerce/header.js";
import "./scripts/ecommerce/ebook.js";
import "./scripts/ecommerce/calculatepadding.js";
import "./scripts/ecommerce/animatenumber.js";
import "./scripts/ecommerce/ecommerce.js";

import "./scripts/slick/slick-carousel.js";
import "./scripts/slick/parallax.js";
import "./scripts/ecommerce/backstage.js";
import "./scripts/ecommerce/background-leaves.js";

import * as bootstrap from 'bootstrap';

const tooltipTriggerList = document.querySelectorAll('.tooltip-backstage');
tooltipTriggerList.forEach(function (element) {
    new bootstrap.Tooltip(element);
});

/* 
const tooltipTriggerList2 = document.querySelectorAll('.tooltip-solutions');
tooltipTriggerList2.forEach(function (element) {
    new bootstrap.Tooltip(element);
});
*/